<ng-container *ngIf="initialize">
<!-- Outer page: white background -->
<div class="hp-outer-page">
  <div class="hp-phone-frame">
    <main class="hp-main" role="main">

      <!-- Logo block -->
      <div class="hp-logo-block">
        <h1 class="hp-logo-title">
          <img src="assets/healthpicks/images/logo.svg" alt="Health Picks" class="hp-logo-img" />
        </h1>
      </div>

      <!-- Input area -->
      <div class="hp-input-area">

        <!-- Unlock icon -->
        <div class="hp-unlock-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 019.9-1"/>
          </svg>
        </div>

        <h2 class="hp-card-title">ロックを解除しました</h2>

        <p class="hp-countdown">
          {{ countdown }}秒後に、{{ appname }}のトップページへ自動的に移動します。
        </p>

        <p class="hp-note">
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>

        <button class="hp-btn-primary" (click)="redirect()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
          トップに戻る
        </button>

      </div>

    </main>
  </div>
</div>
</ng-container>
